import BasePresenter from "../../redare/presenter/BasePresenter";
import * as MenuRolePermissionHttp from "../http/MenuRolePermissionHttp";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

export default class MenuRolePermissionPresenter extends BasePresenter {

    /**
     * @param body: {userId}
     * @param query: {}
     * @returns Promise
     */
    findMenuRolePermissionByUserId(body, query, success, fails) {

        if (this._onBeforeFindMenuRolePermissionByUserId) {
            let data = this._onBeforeFindMenuRolePermissionByUserId(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        MenuRolePermissionHttp.findMenuRolePermissionByUserId(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindMenuRolePermissionByUserIdSuccess) {
                    result = this._onBeforeFindMenuRolePermissionByUserIdSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindMenuRolePermissionByUserIdSuccess) {
                    this.view._onFindMenuRolePermissionByUserIdSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {userId}
     * @param query: {}
     * @returns Promise
     */
    findMenuRolePermissionByUserIdForApp(body, query, success, fails) {

        if (this._onBeforeFindMenuRolePermissionByUserIdForApp) {
            let data = this._onBeforeFindMenuRolePermissionByUserIdForApp(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        MenuRolePermissionHttp.findMenuRolePermissionByUserIdForApp(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindMenuRolePermissionByUserIdForAppSuccess) {
                    result = this._onBeforeFindMenuRolePermissionByUserIdForAppSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindMenuRolePermissionByUserIdForAppSuccess) {
                    this.view._onFindMenuRolePermissionByUserIdForAppSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

}